// src/config/seoConfig.js
export const seoConfig = [
  {
    path: "/",
    title: "PartsLokator – Intelligent Used Auto Parts Marketplace",
    description:
      "Find quality used auto parts quickly using Kato AI. Search, compare, and buy from verified sellers to keep your vehicle running smoothly.",
    keywords:
      "used auto parts, car parts marketplace, buy car parts online, PartsLokator, AI auto parts search",
  },
  {
    path: "/:slug",
    title: "Seller Profile – PartsLokator",
    description: "View seller profile and available parts.",
    keywords: "auto parts, seller profile, used parts",
    robots: "noindex, nofollow",
  },
  {
    path: "/listings",
    title: "Browse Auto Parts Listings – PartsLokator",
    description:
      "Explore thousands of used auto parts for all makes and models. Filter by price, location, and seller rating.",
    keywords:
      "auto parts listings, used car parts, car parts for sale, buy used auto parts, vehicle parts catalog",
  },
  {
    path: "/listings/category",
    title: "Auto Parts by Category – PartsLokator",
    description:
      "Discover used car parts by category, including engine, transmission, suspension, and more.",
    keywords:
      "engine parts, transmission parts, suspension, brakes, car components by category",
  },
  {
    path: "/register",
    title: "Register Your Account – PartsLokator",
    description:
      "Join PartsLokator to buy and sell used auto parts. Free registration for individuals and businesses.",
    keywords:
      "register PartsLokator, sign up auto parts account, seller registration, buyer registration",
  },
  {
    path: "/list-inventory",
    title: "List Your Inventory – PartsLokator Memberships",
    description:
      "Become a verified seller and showcase your used parts to thousands of buyers. Explore membership options.",
    keywords:
      "list inventory, sell auto parts, seller membership, car parts business, used car parts dealer",
  },
  {
    path: "/upgrade-membership",
    title: "Upgrade Membership – PartsLokator",
    description:
      "Unlock advanced selling tools and premium visibility for your listings.",
    keywords:
      "membership upgrade, seller tools, premium listings, auto parts business growth",
  },
  {
    path: "/payment",
    title: "Secure Payment – PartsLokator",
    description:
      "Complete your payment securely with Stripe for parts or membership purchases.",
    keywords:
      "secure payment, stripe checkout, car parts payment, online transaction, parts purchase",
  },
  {
    path: "/add-ons",
    title: "Add-Ons & Extras – PartsLokator",
    description:
      "Enhance your seller profile with marketing tools and listing upgrades.",
    keywords:
      "seller add-ons, marketing tools, premium listings, auto parts visibility",
  },
  {
    path: "/profile/saved-parts",
    title: "Saved Auto Parts – PartsLokator",
    description:
      "Access and manage your favorite used car parts and watchlist.",
    keywords: "saved parts, watchlist, favorite auto parts, car parts wishlist",
  },
  {
    path: "/profile/notifications",
    title: "Notifications – PartsLokator",
    description:
      "Stay updated with alerts about messages, listings, and buyer activity.",
    keywords:
      "notifications, alerts, buyer updates, messages, listing notifications",
  },
  {
    path: "/dashboard",
    title: "Seller Dashboard – PartsLokator",
    description: "Manage your listings, sales, and analytics in one place.",
    keywords:
      "seller dashboard, manage listings, auto parts analytics, sales tracking",
  },
  {
    path: "/dashboard/profile",
    title: "Seller Profile Settings – PartsLokator",
    description:
      "Update your business profile, contact info, and inventory details.",
    keywords:
      "seller profile, business info, contact settings, inventory management",
  },
  {
    path: "/dashboard/billing",
    title: "Billing & Invoices – PartsLokator",
    description:
      "Manage your payments, invoices, and subscription billing history.",
    keywords:
      "billing, invoices, payments, subscription management, seller payments",
  },
  {
    path: "/profile",
    title: "Buyer Profile – PartsLokator",
    description: "View and update your buyer account details and preferences.",
    keywords:
      "buyer profile, account settings, preferences, auto parts buyer account",
  },
  {
    path: "/profile/messages",
    title: "Messages – PartsLokator",
    description:
      "Chat securely with sellers and buyers about auto parts listings.",
    keywords:
      "messages, chat with sellers, buyer communication, car parts inquiries",
  },
  {
    path: "/dashboard/add-part",
    title: "Add a New Part – PartsLokator",
    description:
      "Create a new listing to sell your used auto part on PartsLokator.",
    keywords: "add new part, sell car part, create listing, auto parts upload",
  },
  {
    path: "/dashboard/bulk-add-parts",
    title: "Bulk Upload Auto Parts – PartsLokator",
    description: "Upload multiple parts at once using our bulk import tool.",
    keywords:
      "bulk upload, import car parts, multiple listings, inventory upload",
  },
  {
    path: "/about",
    title: "About PartsLokator – Our Mission & Vision",
    description:
      "Learn how PartsLokator is transforming the auto parts industry with AI technology.",
    keywords:
      "about PartsLokator, company mission, AI auto parts, business vision",
  },
  {
    path: "/privacy",
    title: "Privacy Policy – PartsLokator",
    description:
      "Understand how we collect, use, and protect your personal data.",
    keywords: "privacy policy, data protection, user data, GDPR compliance",
  },
  {
    path: "/faq",
    title: "Frequently Asked Questions – PartsLokator",
    description:
      "Find answers to common questions about buying and selling used auto parts.",
    keywords: "faq, auto parts help, buying guide, selling guide, support",
  },
  {
    path: "/terms",
    title: "Terms & Conditions – PartsLokator",
    description: "Review our terms of service for buyers and sellers.",
    keywords: "terms of service, conditions, policies, user agreement",
  },
  {
    path: "/contact-us",
    title: "Contact Us – PartsLokator",
    description: "Reach out to our team for support or partnership inquiries.",
    keywords: "contact PartsLokator, customer support, help desk, partnership",
  },
  {
    path: "/enterprise-sales",
    title: "Enterprise Sales – PartsLokator",
    description:
      "Partner with PartsLokator for enterprise-level inventory and data integration.",
    keywords:
      "enterprise sales, business integration, bulk inventory, B2B auto parts",
  },
  {
    path: "/ai-search-results",
    title: "AI-Powered Search Results – PartsLokator",
    description:
      "Explore results generated by Kato AI based on your part needs.",
    keywords:
      "AI search, Kato AI, smart search, auto parts results, intelligent matching",
  },
  {
    path: "/search-results",
    title: "Search Results – PartsLokator",
    description:
      "Browse all listings that match your search for used auto parts.",
    keywords:
      "search results, used car parts, vehicle parts search, auto parts finder",
  },
  {
    path: "/inquire-part",
    title: "Inquire About a Part – PartsLokator",
    description: "Contact sellers directly about a specific car part listing.",
    keywords: "inquire part, contact seller, car parts inquiry, message seller",
  },
  {
    path: "/partDetail",
    title: "Part Details – PartsLokator",
    description: "View detailed information about this auto part.",
    keywords:
      "part details, auto part info, car part specifications, buy used part",
    robots: "noindex, nofollow",
  },
  {
    path: "/dashboard/settings",
    title: "Seller Settings – PartsLokator",
    description: "Manage your seller account settings and preferences.",
    keywords: "seller settings, account preferences, business profile",
    robots: "noindex, nofollow",
  },
  {
    path: "/profile/settings",
    title: "Buyer Settings – PartsLokator",
    description: "Manage your buyer account settings and preferences.",
    keywords: "buyer settings, account preferences, user profile",
    robots: "noindex, nofollow",
  },
  {
    path: "*",
    title: "Page Not Found – PartsLokator",
    description:
      "The page you’re looking for doesn’t exist. Return to the homepage to find used auto parts.",
    keywords: "404, page not found, auto parts search, PartsLokator homepage",
  },
];
